import axios from "axios";
import { getToken } from "@/lib/api";

// Axios instance for the panel's own backend endpoints (/api/panel/*),
// which are NOT proxied to the upstream mobile API.
const PANEL_BASE = process.env.REACT_APP_PANEL_API_BASE || "/api";
const panelApi = axios.create({ baseURL: PANEL_BASE });
panelApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default panelApi;
